import React from "react";
import "../../theme/styles.css";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
});

const HomeScreen = () => {
  return (
    <div className="oldHomePage">
      <img
        src={require("../../images/logo_med.png")}
        className="oldLogo"
        alt="Mucky Duck"
      />
    </div>
  );
};

export default withStyles(styles)(HomeScreen);



// WEBPACK FOOTER //
// ./src/screens/general/HomeScreen.js